import { Core } from '@springtree/eva-services-core';
import buildServiceState from '../../builders/build-service-state.js';
import currentUserState from '../current-user/current-user-state.js';
import productListState from './product-list-state.js';
const productListAvailabilityState = buildServiceState({
    allowEmptyRequest: false,
    key: 'productListAvailability',
    service: Core.GetProductAvailability,
    beforeRequest: ({ req, get }) => {
        const currentUser = get(currentUserState.response);
        const searchResult = get(productListState.response);
        const searchProducts = searchResult?.Products ?? [];
        const productIds = searchProducts.map(product => product?.product_id).filter(productId => !!productId);
        if (!productIds.length) {
            return;
        }
        const organizationUnitsForPickup = [];
        if (currentUser?.User?.CurrentOrganizationID) {
            organizationUnitsForPickup.push(currentUser.User.CurrentOrganizationID);
        }
        const newRequest = {
            Options: {
                Bundles: {
                    IncludeBundleInformation: true,
                },
                Delivery: {
                    AvailabilityDate: true,
                },
                Pickup: {
                    AvailabilityDate: true,
                    OrganizationUnitIDs: organizationUnitsForPickup,
                },
                QuantityAvailable: true,
                ProductAvailabilityDetails: {
                    OrganizationUnitIDs: organizationUnitsForPickup,
                    ProductIDs: productIds,
                },
            },
            ...req,
            // Override the product ids
            //
            Products: productIds.map((productId) => { return { ID: productId, QuantityRequested: 1 }; }),
        };
        return newRequest;
    },
});
export default productListAvailabilityState;
//# sourceMappingURL=product-list-availability-state.js.map